import { ListPrimaryKeyId, PrimaryKeyId } from "./brands.model";
import { ISettingsReportOptions } from "./report-options.model";

/** Report settings enum */
export enum IReportSettings {
  DEFAULT_IMAGE_QUALITY = 60, // image quality in reports
  DEFAULT_CAMERA_QUALITY = 80, // image quality by device camera
}

export interface IReportUser {
  company: string;
  /** Firstname and Lastname */
  name: string;
  position: string;
}

export interface IReportProject {
  name: string;
  reference: string;
  client: string;
  address: string;
  city: string;
  state: string;
  postcode: string;
  type: number;
}

/** Report site interface */
export interface IReportSite {
  cloudId: ListPrimaryKeyId;
  floor: string;
  unit: string;
  address: string;
}

export interface IReportSiteSelector extends IReportSite {
  defectsCount: number;
  checked: boolean;
}

/**
 * Populates contractor filter on report options generater
 */
export interface IReportContractorSelector {
  /** -1 is for Unassigned case */
  cloudId: PrimaryKeyId | -1;
  name: string;
  company: string;
  hasDefects: boolean;
}

/**
 * Data passed between report options and picker components
 */
export interface IReportGenerateOptions {
  /** -1 is for Default Template, otherwise use database id */
  templateId: PrimaryKeyId | -1;
  filename: string;
  lists: ListPrimaryKeyId[];
  options: ISettingsReportOptions;
  date: string;
  statusTypes: number[];
  priorityTypes: number[];
  contractors: IReportContractorSelector[];
}

/** Report defect interface */
export interface IReportDefect {
  defectNumberString: string;
  defectNumber: number;
  id: number;
  area: string;
  element: string;
  issue: string;
  comments: string;
  status: number;
  assignment: string[];
  /** used in query/data build only */
  contractorCompany?: string;
  /** used in query/data build only */
  contractorName?: string;
}

/** PDF Data interface */
export interface IReportPdfData {
  name: string;
  type: number;
  address: string;
  city: string;
  reference: string;
  items: IReportDefectTable[];
}

/** Report Defect table interface */
export interface IReportDefectTable {
  unit: string;
  address: string;
  city: string;
  areas: IReportAreas[];
}

/** Report areas interface */
export interface IReportAreas {
  name: string;
  defects: IReportDefects[];
}

/** Report defects interface */
export interface IReportDefects {
  area: string;
  element: string;
  issue: string;
  comments: string;
  photos: string[];
}

/** Data row from SQL for CSV report */
export interface IReportCsvSiteData {
  address: string;
  unit: string;
  floor: string;
  area: string;
  element: string;
  issue: string;
  comments: string;
  created: string;
  completed: string;
  status: number;
  defectNumber: number;
  /** Grouped contractors in single string */
  assignedTo: string;
}

/** File types enum */
export enum IFileType {
  PDF = "pdf",
  CSV = "csv",
  XLS = "XLS",
  XLSX = "XLSX",
  TXT = "txt",
  DOC = "doc",
  DOCX = "docx",
}
